export const WL_INTEGRATION_SLUG_ALLESAUTO = 'alles.auto';
export const WL_INTEGRATION_SLUG_AMZ_M_ = 'ds-amz-muenchen-de';
export const WL_INTEGRATION_SLUG_PEG_AMZ_M = 'peugeot-amz-muenchen-de';
export const WL_INTEGRATION_SLUG_AUTO_EUROP = 'autohauseuropa-de';
export const WL_INTEGRATION_SLUG_SCHNEIDER_GRUPPE = 'schneidergruppe-de';
export const WL_INTEGRATION_SLUG_BOB_AUTOMOBILE = 'bob-automobile-de';
export const WL_INTEGRATION_SLUG_AIS_TOYOTA = 'ais-toyota-de';
export const WL_INTEGRATION_SLUG_ERTL_GRUPPE = 'ertl-gruppe-de';
export const WL_INTEGRATION_SLUG_DIT_MUENCHEN = 'dit-muenchen-de';
export const WL_INTEGRATION_SLUG_DIT_MAGDEBURG = 'dit-magdeburg-de';
export const WL_INTEGRATION_SLUG_DIT_HALLE = 'dit-halle-de';
export const WL_INTEGRATION_SLUG_DIT_GOETTINGEN = 'dit-goettingen-de';
export const WL_INTEGRATION_SLUG_DIT_FRANKENGARAGE = 'dit-frankengarage-de';
export const WL_INTEGRATION_SLUG_AHG_ONLINE = 'ahg-online-de';
export const WL_INTEGRATION_SLUG_AUTO_LEVY = 'autolevy-de';
export const WL_INTEGRATION_SLUG_KAHLE = 'kahle-de';
export const WL_INTEGRATION_SLUG_AUTOHAUS_RUESCHKAMP = 'autohaus-rueschkamp-de';
export const WL_INTEGRATION_SLUG_AUTOHAUS_SUK = 'autohaus-suk-de';
export const WL_INTEGRATION_SLUG_HYUNDAI_AUTO_KUS = 'hyundai-auto-kus-de';
export const WL_INTEGRATION_SLUG_AUREGO = 'aurego-de';
export const WL_INTEGRATION_WINTER_LAUSITZ = 'winter-lausitz-de';
export const WL_INTEGRATION_SLUG_WALDHAUSEN = 'waldhausen-buerkel-de';
export const WL_INTEGRATION_SLUG_DIT_ERFURT = 'dit-erfurt-de';
export const WL_INTEGRATION_SLUG_TOYOTA_NEFF = 'toyota-neff-de';
export const WL_INTEGRATION_SLUG_AUTOHAUS_LADEMANN = 'autohaus-lademann-de';
export const WL_INTEGRATION_SLUG_AUTOHAUS_SCHWARTE = 'autohaus-schwarte-de';
export const WL_INTEGRATION_SLUG_BRAASCH_GRUPPE = 'braasch-gruppe-de';
export const WL_INTEGRATION_SLUG_AUTO_HEMPEL = 'autohempel-de';
export const WL_INTEGRATION_SLUG_SEITZ_AUTOHAUS = 'seitz-autohaus-de';
export const WL_INTEGRATION_SLUG_AUTOHAUS_BRUCKER = 'autohaus-brucker-de';
export const WL_INTEGRATION_SLUG_AUTOCENTER_DRESDEN = 'autocenter-dresden-de';
export const WL_INTEGRATION_SLUG_OPEL_SCHWEDT = 'opel-schwedt-de';
export const WL_INTEGRATION_SLUG_AUTOSKAUFTMANBEIKOCH =
  'autoskauftmanbeikoch-de';
export const WL_INTEGRATION_SLUG_NOWAG_BULLSHITMEDIA = 'nowag-com';

/**
 * This function should query the Gateway and return a list of
 * all Whitelabel integration slugs, but as we don't have such an
 * endpoint at the moment, we are only returning a hardcoded list
 * of integration slugs that were defined in the PoC.
 */

export const getWhiteLabelIntegrationSlugs = async (): Promise<string[]> => {
  return [
    WL_INTEGRATION_SLUG_ALLESAUTO,
    WL_INTEGRATION_SLUG_AMZ_M_,
    WL_INTEGRATION_SLUG_PEG_AMZ_M,
    WL_INTEGRATION_SLUG_AUTO_EUROP,
    WL_INTEGRATION_SLUG_SCHNEIDER_GRUPPE,
    WL_INTEGRATION_SLUG_BOB_AUTOMOBILE,
    WL_INTEGRATION_SLUG_AIS_TOYOTA,
    WL_INTEGRATION_SLUG_ERTL_GRUPPE,
    WL_INTEGRATION_SLUG_DIT_MUENCHEN,
    WL_INTEGRATION_SLUG_DIT_MAGDEBURG,
    WL_INTEGRATION_SLUG_DIT_HALLE,
    WL_INTEGRATION_SLUG_DIT_GOETTINGEN,
    WL_INTEGRATION_SLUG_DIT_FRANKENGARAGE,
    WL_INTEGRATION_SLUG_AHG_ONLINE,
    WL_INTEGRATION_SLUG_AUTO_LEVY,
    WL_INTEGRATION_SLUG_KAHLE,
    WL_INTEGRATION_SLUG_AUTOHAUS_RUESCHKAMP,
    WL_INTEGRATION_SLUG_AUTOHAUS_SUK,
    WL_INTEGRATION_SLUG_HYUNDAI_AUTO_KUS,
    WL_INTEGRATION_SLUG_AUREGO,
    WL_INTEGRATION_WINTER_LAUSITZ,
    WL_INTEGRATION_SLUG_WALDHAUSEN,
    WL_INTEGRATION_SLUG_DIT_ERFURT,
    WL_INTEGRATION_SLUG_TOYOTA_NEFF,
    WL_INTEGRATION_SLUG_AUTOHAUS_LADEMANN,
    WL_INTEGRATION_SLUG_AUTOHAUS_SCHWARTE,
    WL_INTEGRATION_SLUG_BRAASCH_GRUPPE,
    WL_INTEGRATION_SLUG_AUTO_HEMPEL,
    WL_INTEGRATION_SLUG_SEITZ_AUTOHAUS,
    WL_INTEGRATION_SLUG_AUTOHAUS_BRUCKER,
    WL_INTEGRATION_SLUG_AUTOCENTER_DRESDEN,
    WL_INTEGRATION_SLUG_OPEL_SCHWEDT,
    WL_INTEGRATION_SLUG_AUTOSKAUFTMANBEIKOCH,
    WL_INTEGRATION_SLUG_NOWAG_BULLSHITMEDIA,
  ];
};

export const detachedWhiteLabelIntegrationSlugs = new Set([
  WL_INTEGRATION_SLUG_BOB_AUTOMOBILE,
]);
